(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myzaya-header"]) return;
  try {
    
  (() => {
    const colors = {zwart:'#171717',black:'#171717',wit:'#f7f5f0',white:'#f7f5f0',creme:'#e8dfcf',cream:'#e8dfcf',beige:'#d8c3a5',bruin:'#7a5136',brown:'#7a5136',camel:'#b98b61',taupe:'#9d8b7d',grijs:'#a8a8a8',grey:'#a8a8a8',gray:'#a8a8a8',blauw:'#3971a8',blue:'#3971a8',navy:'#172d4f',donkerblauw:'#172d4f',lichtblauw:'#9fcce3',groen:'#5b7d55',green:'#5b7d55',olijf:'#73784d',olijfgroen:'#73784d',rood:'#c73e43',red:'#c73e43',roze:'#e9a7b4',pink:'#e9a7b4',paars:'#806296',purple:'#806296',geel:'#e5c24a',yellow:'#e5c24a',oranje:'#df8441',orange:'#df8441',goud:'#c5a253',gold:'#c5a253',zilver:'#b9bdc2',silver:'#b9bdc2',multi:'conic-gradient(#ec6f7c,#f2c94c,#6fcf97,#56ccf2,#bb6bd9,#ec6f7c)',multicolor:'conic-gradient(#ec6f7c,#f2c94c,#6fcf97,#56ccf2,#bb6bd9,#ec6f7c)'};
    const key = value => value.toLowerCase().trim().replace(/[^a-z0-9à-ÿ]+/g,' ').split(' ')[0];
    const enhanceSwatches = root => {
      root.querySelectorAll('variant-radios fieldset, variant-selects fieldset, product-form fieldset').forEach(fieldset => {
        const legend = fieldset.querySelector('legend');
        if (!legend || !/(kleur|color|colour)/i.test(legend.textContent)) return;
        fieldset.classList.add('mz-color-fieldset');
        fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
          const label = fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          if (!label) return;
          const value = (input.value || label.textContent).trim();
          label.style.setProperty('--mz-swatch', colors[key(value)] || '#d9d0ca');
          label.title = value;
          label.setAttribute('aria-label', value);
        });
      });
    };
    const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'nl-NL',{style:'currency',currency:currency || 'EUR'}).format(amount / 100);
    let cartBusy = false;
    const enhanceCart = async () => {
      const footer = document.querySelector('cart-drawer .drawer__footer, #CartDrawer .drawer__footer');
      const template = document.querySelector('#mz-cart-progress-template');
      if (!footer || !template || footer.querySelector('.mz-cart-progress') || cartBusy) return;
      cartBusy = true;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
        const cart = await response.json();
        const fragment = template.content.cloneNode(true);
        const panel = fragment.querySelector('.mz-cart-progress');
        const threshold = Number(panel.dataset.threshold || 5000);
        const ratio = Math.min(100, Math.max(0, cart.total_price / threshold * 100));
        const remaining = Math.max(0, threshold - cart.total_price);
        const message = cart.item_count === 0 ? panel.dataset.progressEmpty : remaining > 0 ? panel.dataset.progressOpen.replace('[amount]', money(remaining, cart.currency)) : panel.dataset.progressDone;
        panel.querySelector('.mz-cart-progress__message').textContent = message;
        panel.querySelector('.mz-cart-progress__bar span').style.width = `${ratio}%`;
        footer.prepend(fragment);
      } catch (error) {
        return;
      } finally {
        cartBusy = false;
      }
    };
    const enhanceCartPage = () => {
      const actions = document.querySelector('.cart__footer .cart__ctas');
      const template = document.querySelector('#mz-cart-progress-template');
      if (!actions || !template || actions.querySelector('.mz-cart-trust')) return;
      actions.append(template.content.querySelector('.mz-cart-trust').cloneNode(true));
    };
    const run = () => { enhanceSwatches(document); enhanceCart(); enhanceCartPage(); };
    document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('cart:updated', enhanceCart);
    new MutationObserver(() => requestAnimationFrame(run)).observe(document.documentElement,{childList:true,subtree:true});
    document.addEventListener('click', event => {
      if (event.target.closest('.mz-mobile-menu__close')) event.target.closest('.mz-mobile-menu').removeAttribute('open');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myzaya-home-preview"] && !Shopify.designMode) return;
  try {
    
  const normalizeZayaColor = (value) => value.toLowerCase().trim().replace(/\s+/g, '-');
  const zayaColors = {
    zwart: '#171717',
    black: '#171717',
    wit: '#f8f6f1',
    white: '#f8f6f1',
    beige: '#d8c7b4',
    bruin: '#7b5743',
    brown: '#7b5743',
    blauw: '#6685a8',
    blue: '#6685a8',
    groen: '#68816a',
    green: '#68816a',
    roze: '#d99aaa',
    pink: '#d99aaa',
    rood: '#b84949',
    red: '#b84949',
    oranje: '#d9894d',
    orange: '#d9894d',
    geel: '#dfc75f',
    yellow: '#dfc75f',
    paars: '#8a709c',
    purple: '#8a709c',
    goudkleur: '#c9a66b',
    gold: '#c9a66b',
    zilver: '#b7b9bd',
    silver: '#b7b9bd',
    khaki: '#a49672',
    taupe: '#9d897d'
  };
  const zayaFallbacks = ['#c8b7aa', '#c85f6a', '#efd993', '#6b7f73', '#7187a5'];

  document.querySelectorAll('[data-zaya-color]').forEach((swatch, index) => {
    const key = normalizeZayaColor(swatch.dataset.zayaColor);
    const direct = zayaColors[key];
    const partial = Object.keys(zayaColors).find((name) => key.includes(name));
    swatch.style.setProperty('--mz-dot', direct || zayaColors[partial] || zayaFallbacks[index % zayaFallbacks.length]);
  });

  } catch(e) { console.error(e); }
})();
})();
